module.exports = new __parcel__URL__("plug.96aead60.svg").toString();